/* eslint-disable @typescript-eslint/no-explicit-any */
import PubSub from 'pubsub-js';
import {
  IEventSubscription,
  IPublishProps,
  SubscribeCb,
} from './event-system.types';

declare global {
  interface Window {
    pubSub: any;
    pubSubscriptions: IEventSubscription[];
  }
}

export class EventSystem {
  public pubSub: PubSubJS.Base;
  private subscriptions: IEventSubscription[] = [];
  constructor() {
    if (window.pubSub) {
      this.pubSub = window.pubSub;
      this.subscriptions =
        window?.pubSubscriptions?.length > 0 ? window.pubSubscriptions : [];
    } else {
      this.pubSub = PubSub;
      this.subscriptions = [];
    }
  }

  public initializePubSub(): void {
    if (!window.pubSub) {
      window.pubSub = this.pubSub;
      window.pubSubscriptions = this.subscriptions;
    }
  }

  public publish<T>(props: IPublishProps<T>): boolean {
    const { topicName, data = '' } = props;
    return this.pubSub.publish(topicName, data); // boolean represents if any subscribers was registered for this topic
  }
  // returns token of the subscription, its necessary to save it in order to clear subs later
  public subscribe<T>(topicName: string, cb: SubscribeCb<T>): string {
    const token = this.pubSub.subscribe(topicName, (msg: string, data: T) =>
      cb(msg, data)
    );
    this.subscriptions.push({ token, topic: topicName, fn: cb });
    this.updateWindowSubscriptions();
    return token;
  }
  // return token of the unsubscribed token
  public unsubscribe(token: string): void {
    const subscription = this.subscriptions.filter(
      (val: IEventSubscription) => val.token === token
    )[0];
    this.subscriptions = this.subscriptions.filter(
      (val: IEventSubscription) => val.token !== token
    );
    this.updateWindowSubscriptions();
    this.pubSub.unsubscribe(subscription.token);
  }

  public unsubscribeAllByTopic(topic: string): void {
    this.subscriptions = this.subscriptions.filter(
      (val: IEventSubscription) => val.topic !== topic
    );
    this.updateWindowSubscriptions();
    this.pubSub.unsubscribe(topic);
  }

  public getSubscription(token: string): IEventSubscription {
    return this.subscriptions.filter(
      (val: IEventSubscription) => val.token === token
    )[0];
  }

  public getAllSubscriptionsByTopic(topic: string): IEventSubscription[] {
    return this.subscriptions.filter(
      (val: IEventSubscription) => val.topic === topic
    );
  }

  // subscriptions by token from all topics
  public countSubscriptions(topic: string): number {
    return this.subscriptions.filter(
      (val: IEventSubscription) => val.topic === topic
    ).length;
  }

  public clearAllSubscriptions(): boolean {
    this.pubSub.clearAllSubscriptions();
    this.subscriptions = [];
    this.updateWindowSubscriptions();
    return true;
  }

  private updateWindowSubscriptions = () => {
    window.pubSubscriptions = this.subscriptions;
  };
}
